import React from 'react';

export const getLinkContext = context => {
  if (process.env.NODE_ENV === 'production') return '/';
  if (['depi', 'depv'].indexOf(context) > -1) return `/${context}/`;
  return `/enplus/${context}/`;
};

export const removeProtocolFromString = url => url.replace(/(^\w+:|^)\/\//, '');

export const MEMBERSHIP_LABELS = {
  grill_producer: 'Produzenten Freizeitartikel',
  hackschnitzel_producer: 'Hersteller und Händler – Hackschnitzel',
  briquet_prodcuer: 'Produzenten, Händler und Anlagenhersteller – Holzbriketts',
  boiler_producer: 'Hersteller Kessel',
  component_producer: 'Hersteller Lagersysteme',
  oven_producer: 'Hersteller Pelletkaminöfen',
  pellet_producer: 'Hersteller Holzpellets',
  pellet_dealer: 'Händler Holzpellets',
  insititute: 'Verbände, Institutionen, Sonstiges',
  contracting: 'Wärmelieferung und Contracting',
  pellet_specialist: 'Pelletfachbetriebe - Fördermitglieder',
  sponsoring_member: 'Weitere Fördermitglieder',
  pure_component_producer: 'Hersteller Komponenten',
};

export const CERTIFICATE_FILTERS = {
  pellets: [
    'producer_certificate',
    'dealer_certificate',
    'service_certificate',
  ],
  hackschnitzel: ['hackschnitzel_certificate'],
  holzbriketts: ['briquet_certificate'],
  depi: [],
  depv: [],
};

export const CERTIFICATE_TO_CONTEXT = {
  producer_certificate: 'pellets',
  dealer_certificate: 'pellets',
  service_certificate: 'pellets',
  briquet_certificate: 'holzbriketts',
  hackschnitzel_certificate: 'hackschnitzel',
};

export const CONTEXT_TO_EXTERNAL_WEBSITE = {
  pellets: 'https://enplus-pellets.de',
  holzbriketts: 'https://enplus-briketts.de',
  hackschnitzel: 'https://enplus-hackschnitzel.de',
  depi: 'https://depi.de',
  depv: 'https://depv.de',
};

export const CERTIFICATE_LABELS = {
  producer_certificate: (
    <React.Fragment>
      EN<i>plus</i>-Pelletproduktion
    </React.Fragment>
  ),
  dealer_certificate: (
    <React.Fragment>
      EN<i>plus</i>-Pellethandel
    </React.Fragment>
  ),
  service_certificate: (
    <React.Fragment>
      EN<i>plus</i>-Pelletdienstleistung
    </React.Fragment>
  ),
  briquet_certificate: (
    <React.Fragment>
      EN<i>plus</i>-Briketts
    </React.Fragment>
  ),
  hackschnitzel_certificate: (
    <React.Fragment>
      EN<i>plus</i>-Hackschnitzel
    </React.Fragment>
  ),
};

export const CERTIFICATE_GROUP_LABELS = {
  producer_certificate: [
    <React.Fragment>
      Zertifizierte EN<i>plus</i>-Pelletproduzenten
    </React.Fragment>,
    'Zertifizierte ENplus-Pelletproduzenten',
  ],
  dealer_certificate: [
    <React.Fragment>
      Zertifizierte EN<i>plus</i>-Pellethändler
    </React.Fragment>,
    'Zertifizierte ENplus-Pellethändler',
  ],
  service_certificate: [
    <React.Fragment>
      Zertifizierte EN<i>plus</i>-Pellet-Dienstleistungsanbieter
    </React.Fragment>,
    'Zertifizierte ENplus-Pellet-Dienstleistungsanbieter',
  ],
  briquet_certificate: [
    <React.Fragment>
      Zertifizierte Unternehmen für EN<i>plus</i>-Briketts
    </React.Fragment>,
    'Zertifizierte Unternehmen für ENplus-Briketts',
  ],
  hackschnitzel_certificate: [
    <React.Fragment>
      Zertifizierte Unternehmen für EN<i>plus</i>-Hackschnitzel
    </React.Fragment>,
    'Zertifizierte Unternehmen für ENplus-Hackschnitzel',
  ],
};

export const CERTIFICATE_GROUP_LABELS_SINGULAR = {
  producer_certificate: (
    <React.Fragment>
      Zertifizierter EN<i>plus</i>-Pelletproduzent
    </React.Fragment>
  ),
  dealer_certificate: (
    <React.Fragment>
      Zertifizierter EN<i>plus</i>-Pellethändler
    </React.Fragment>
  ),
  service_certificate: (
    <React.Fragment>
      Zertifizierter EN<i>plus</i>-Pellet-Dienstleistungsanbieter
    </React.Fragment>
  ),
  briquet_certificate: (
    <React.Fragment>
      Zertifiziertes Unternehmen für EN<i>plus</i>-Briketts
    </React.Fragment>
  ),
  hackschnitzel_certificate: (
    <React.Fragment>
      Zertifiziertes Unternehmen für EN<i>plus</i>-Hackschnitzel
    </React.Fragment>
  ),
};

export const CERT_TYPE_LABELS = {
  pellets: 'Handel von Holzpellets (als lose Ware)',
  bagged_pellets: 'Handel von Holzpellets (als Sackware)',
};

export const SERVICE_LABELS = {
  delivery: 'Endkundenlieferung',
  storage: 'Lagerbetrieb',
  bagging: 'Absackung',
};

export const QUALITY_LABELS = {
  a1: (
    <React.Fragment>
      EN<i>plus</i> A1
    </React.Fragment>
  ),
  a2: (
    <React.Fragment>
      EN<i>plus</i> A2
    </React.Fragment>
  ),
  b: (
    <React.Fragment>
      EN<i>plus</i> B
    </React.Fragment>
  ),
};

export const MANUFACTURING_LABELS = {
  bale: 'Presskammer',
  eccentric: 'Exzenterpresse',
  extruder: 'Extruderpresse',
};

export const HACKSCHNITZEL_QUALITY_LABELS = {
  a1: (
    <React.Fragment>
      EN<i>plus</i>-A1-P31S
    </React.Fragment>
  ),
  a2: (
    <React.Fragment>
      EN<i>plus</i>-A2-P31S
    </React.Fragment>
  ),
  b: (
    <React.Fragment>
      EN<i>plus</i>-B-P31S
    </React.Fragment>
  ),
  'a1-45': (
    <React.Fragment>
      EN<i>plus</i>-A1-P45S
    </React.Fragment>
  ),
  'a2-45': (
    <React.Fragment>
      EN<i>plus</i>-A2-P45S
    </React.Fragment>
  ),
  'b-45': (
    <React.Fragment>
      EN<i>plus</i>-B-P45S
    </React.Fragment>
  ),
};

export const INACTIVIY_REASON_LABELS = {
  locked: 'Gesperrt',
  suspended: 'Suspendiert',
  terminated: 'Beended',
  expired: 'Abgelaufen',
};

export const CATEGORY_LABELS = {
  producer: 'Produzent',
  dealer_bagged: 'Händler von Sackware',
  dealer_loose: 'Händler von losen Pellets',
  dealer_loose_no_physical: 'Händler von losen Pellets ohne physischen Kontakt',
  service_provider: 'Dienstleister',
  bagging: 'Absackung von Pellets',
  storing: 'Lagerung von Pellets (Endkundenhandel)',
  small_delivery: 'Kleinlieferung ≤ 20t',
};

export const ACTIVITY_LABELS = {
  bagging: 'Absackung von Pellets',
  storing: 'Lagerung von Pellets (Endkundenhandel)',
  small_delivery: 'Kleinlieferung ≤ 20t',
};

export const MULTISITE_CATEGORY_LABELS = {
  production: 'Produktion',
  bagging: 'Absackung',
  storage: 'Lagerung',
  retail: 'Handelsstandort',
}
